export default "__VITE_ASSET__B6hM1t7z__"